import { React, useState, useEffect, Card, Toast, Breadcrumb, CustomTable, _formatDate, showCustomConfirmMessage, Icon, useUser } from "../utils/commonImports";
import dayjs from "dayjs";
import { Alert, Button, DatePicker } from "antd";
import { _api } from '../auth/Api';
import Select from "react-select";
import { customStyleMd } from "../utils/common";
import { getPageRights } from "../utils/accessPages";
import Swal from "sweetalert2";
import { _exportToExcel } from "../helper/ExportToExcel";

const TestDrives = () => {
  const [testDrives, setTestDrives] = useState([]);
  const [dealerDrp, setDealerDrp] = useState([]);
  const [vehiclesDrp, setVehiclesDrp] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const rights = getPageRights(userPages, 6);
  const [showExp, setShowExp] = useState({ isShow: false, msg: "" });
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    phoneNo: "",
    vehicleName: "",
    dealerId: 0,
    status: "",
    isCreatedDate: null,
    dateTo: null,
    dateFrom: null,
  });

  useEffect(() => {
    _getTestDrives();
    _getDealersDpr();
    _getVehiclesDpr()
  }, []);

  const _getDealersDpr = async () => {
    const payload = { dealerName: "", phone: "", cityId: null, region: "", code: "", ntnDealer: "", createDate: "", page: { pageNo: 0, numberOfRecords: 0, }, };
    try {
      await _api("POST", "Dealer/GetAllDealer", payload, (res) => {
        if (res.isSuccess) {
          const x = res.data?.map((t) => ({
            label: t.dealerName,
            value: t.dealerId
          }));
          setDealerDrp(x)
        }
      })
    } catch (error) {
      console.log("API Error", error?.message)
    }
  }

  const _getVehiclesDpr = async () => {
    try {
      await _api("GET", "Vehicle/GetDistinctVehicles", null, (res) => {
        if (res.isSuccess) {
          const List = res.data.map((v) => ({
            value: v.id,
            label: v.itemName,
          }));
          setVehiclesDrp(List);
        }
      });
    } catch (error) {
      console.log("API Error", error?.message);
    }
  };

  const _getTestDrives = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      id: 0,
      name: filterValues.name || "",
      email: filterValues.email || "",
      phoneNo: filterValues.phoneNo || "",
      vehicleName: filterValues.vehicleName || "",
      dealerId: filterValues.dealerId?.value || null,
      status: filterValues.status?.value || "",
      isCreatedDate: filterValues.isCreatedDate?.value,
      scheduledDateFrom: filterValues.dateFrom ? dayjs(filterValues.dateFrom).format("YYYY-MM-DD") : null,
      scheduledDateTo: filterValues.dateTo ? dayjs(filterValues.dateTo).format("YYYY-MM-DD") : null,
      createdDateFrom: filterValues.dateFrom ? dayjs(filterValues.dateFrom).format("YYYY-MM-DD") : null,
      createdDateTo: filterValues.dateTo ? dayjs(filterValues.dateTo).format("YYYY-MM-DD") : null,
      //scheduledDate: filterValues.dateTo ? dayjs(filterValues.dateTo).format("YYYY-MM-DD") : null,
      //createdDate: filterValues.dateFrom ? dayjs(filterValues.dateFrom).format("YYYY-MM-DD") : null,
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };

    try {
      setLoading(true);
      await _api("POST", "TestDrive/GetAllTestDrives", payload, (res) => {
        if (res.isSuccess) {
          setTestDrives(res.data || []);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setTestDrives([]);
          Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setTestDrives([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch test drives" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getTestDrives(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    setShowExp({ isShow: false, msg: "" })
    const resetFilters = { name: "", phoneNo: "", email: "", dealerId: null, status: "", vehicleName: "", isCreatedDate: null, dateTo: null, dateFrom: null };
    setFilters(resetFilters);
    setPage(1);
    _getTestDrives(resetFilters, 1, pageSize);
  };

  const handleApply = () => {
    const { name, phoneNo, email, status, vehicleName, dealerId, dateTo, dateFrom, isCreatedDate } = filters;
    if (!name && !status && !vehicleName && !dealerId && !phoneNo && !email && !dateTo && !dateFrom && !isCreatedDate) {
      setShowExp({ isShow: true, msg: "NOTE: Please fill at least one filter" })
      return;
    }
    if (isCreatedDate && !dateTo && !dateFrom) {
      setShowExp({ isShow: true, msg: "NOTE: Please select (to) & (from) Date too." })
      return;
    }
    _getTestDrives(filters, 1, pageSize);
  };

  const columns = [
    {
      title: "Customer",
      dataIndex: "firstName",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          {/* <Avatar src={null}>{record.firstName?.charAt(0).toUpperCase()}</Avatar> */}
          <div>
            <div>{record.firstName} {record.lastName}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Contact Info",
      dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.phone}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    {
      title: "Dealer & Vehicle", dataIndex: "vehicleName", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {row.dealerName}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row.vehicleName}
          </span>
        </div>
      )
    },
    {
      title: "Created On",
      dataIndex: "createDate",
      render: (createDate) => _formatDate(createDate)
    },
    {
      title: "Scheduled On", dataIndex: "scheduledDate", render: (_, row) => (
        <div className="d-flex flex-column">
          <span style={{ fontSize: "14px" }}>
            {_formatDate(row?.scheduledDate)}
          </span>
          <span style={{ fontSize: "12px", color: "#6c757d" }}>
            {row?.scheduledTime ? dayjs(row?.scheduledTime, 'HH:mm:ss').format('hh:mm A') : '-'}
          </span>
        </div>
      )
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span className={`badge ${status === 'Confirmed' ? 'bg-success' : status === 'Rejected' ? 'bg-danger' : 'bg-warning'}`}>{status || "Unknown"}</span>
      ),
    },
    {
      title: "Approval",
      dataIndex: "actions",
      render: (_, record) => {
        if (record.status === "Pending") {
          return (
            <div className="d-flex gap-2">
              {rights && rights?.edit ? (<>
                <Button onClick={() => handleStatusUpdate(record, "Confirmed")} size="small" className="btn-outline-success" icon={<Icon icon="feather:check" />} />
                <Button onClick={() => handleStatusUpdate(record, "Rejected")} size="small" danger icon={<Icon icon="feather:x" />} /></>
              ) : (
                <Button size="small" disabled title="Action Not Allowed">Not Allowed </Button>
              )}
            </div>
          );
        }
        return <Icon icon="mdi:file-check-outline" fontSize={20} color="green" />;
      },
    },
  ];

  const handleStatusUpdate = async (record, status) => {
    let reason = "";

    if (status === "Rejected") {
      const { value: inputReason, isConfirmed } = await Swal.fire({
        title: "Reject Test Drive",
        input: "textarea",
        //       inputLabel: "Reason for Rejection",
        inputPlaceholder: "Enter rejection reason...",
        inputAttributes: {
          'aria-label': 'Enter rejection reason'
        },
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Reject",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        inputValidator: (value) => {
          if (!value) {
            return "Rejection reason is required!";
          }
        },
        customClass: {
          popup: 'swal-toast-style',
          title: 'swal-title-small'
        }
      });

      if (!isConfirmed) return;
      reason = inputReason;
    } else {
      const isYes = await showCustomConfirmMessage({
        message: `Are you sure you want to ${status} this?`,
        icon: status === "Confirmed" ? "info" : "warning"
      });
      if (!isYes) return;
    }

    const payload = {
      testDriveId: record.testDriveId,
      status,
      userId: record.userId,
      remarks: reason || ""
    };

    try {
      await _api("POST", "TestDrive/ApproveTestDrive", payload, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: "success", title: res?.message });
          _getTestDrives();
        } else {
          Toast.fire({ icon: "error", title: res?.message });
        }
      });
    } catch (error) {
      console.error(error);
      Toast.fire({ icon: "error", title: "Action failed" });
    }
  };

  const xlsColumns = [
    { title: "User Id", dataIndex: "userId" },
    { title: "First Name", dataIndex: "firstName" },
    { title: "Last Name", dataIndex: "lastName" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "phone" },
    { title: "Vehicle", dataIndex: "vehicleName" },
    { title: "Dealer", dataIndex: "dealerName" },
    { title: "Scheduled Date", dataIndex: "scheduledDate" },
    { title: "Scheduled Time", dataIndex: "scheduledTime" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      id: 0,
      name: "",
      email: "",
      phoneNo: "",
      vehicleName: "",
      dealerId: null,
      status: "",
      scheduledDate: null,
      createdDate: null,
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      },
    };

    try {
      await _api("POST", "TestDrive/GetAllTestDrives", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            scheduledDate: _formatDate(x.scheduledDate),
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Test Drives",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Test Drives" />
      {filterBtnShow && (
        <Card className="mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  value={filters.name}
                  onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone No"
                  value={filters.phoneNo}
                  onChange={(e) => setFilters({ ...filters, phoneNo: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <Select
                  // options={vehicleOptions}
                  options={[
                    { label: "Alsvin", value: "alsvin" },
                    { label: "Karvaan", value: "karvaan" },
                    { label: "Oshan", value: "oshan" },
                    { label: "Sherpa", value: "sherpa" }
                  ]}
                  value={vehiclesDrp.find(opt => opt.label === filters.vehicleName) || null}
                  onChange={(val) => setFilters({ ...filters, vehicleName: val?.label || "" })}
                  placeholder="Vehicle Name"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={dealerDrp}
                  value={filters.dealerId}
                  onChange={(val) => setFilters({ ...filters, dealerId: val })}
                  placeholder="Select Dealer"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  placeholder="Select Status"
                  value={filters.status}
                  onChange={(val) => setFilters({ ...filters, status: val })}
                  options={[
                    { value: "Pending", label: "Pending" },
                    { value: "Confirmed", label: "Confirmed" },
                    { value: "Rejected", label: "Rejected" },
                  ]}
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <Select
                  placeholder="Select Date Type"
                  value={filters.isCreatedDate}
                  onChange={(val) => setFilters({ ...filters, isCreatedDate: val })}
                  options={[
                    { value: true, label: "Created Date" },
                    { value: false, label: "Scheduled Date" },
                  ]}
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.dateFrom ? dayjs(filters.dateFrom) : null}
                  onChange={(date) => setFilters({ ...filters, dateFrom: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.dateTo && current > dayjs(filters.dateTo)) return true;
                    return false;
                  }}
                  placeholder={filters.isCreatedDate?.value === true ? "Created Date (From)" : filters.isCreatedDate?.value === false ? "Scheduled Date (From)" : "Select Date Type"}
                  disabled={filters.isCreatedDate === null || undefined}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.dateTo ? dayjs(filters.dateTo) : null}
                  onChange={(date) => setFilters({ ...filters, dateTo: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (filters.dateFrom && current < dayjs(filters.dateFrom)) return true;
                    return false;
                  }}
                  placeholder={filters.isCreatedDate?.value === true ? "Created Date (To)" : filters.isCreatedDate?.value === false ? "Scheduled Date (To)" : "Select Date Type"}
                  disabled={!filters.dateFrom && filters.isCreatedDate === null || undefined}
                />
              </div>

            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp.isShow && (
                  <Alert
                    showIcon
                    message={showExp.msg}
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>

        </Card>
      )}
      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Test Drives
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={testDrives}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "testDriveId",
            emptyText: "No test drives found",
            pageKey: 6
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: testDrives.length
          }}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
};

export default TestDrives;